function Header(){
    return (
        <header>
            <h1>Periodic Table</h1>
        </header>
    )
}

export default Header;